import * as navigation from 'Navigation';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';

export default class EntityResultsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: MODEL_NAMES.Results,
      closeable: false,
      preferenceKey: 'entity-results',
    };
  }
}
